import { PortalTelemetryEvent } from '../../app/telemetry/portalTelemetryEvents';
import { PortalTelemetryScreen } from '../../app/telemetry/portalTelemetryScreens';
import { validationIssues } from '../../app/telemetry/validationTelemetry';
import { portalAction, portalScreenContext, trackPortalEvent } from '../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../app/telemetry/usePortalTelemetry';
import { Box, Paper, Grid, Typography, Button } from "@mui/material";
import BackToRequests from "./BackToRequests";
import AppTextareaInput from "../../app/components/AppTextareaInput";
import RequestFormModel from "./models/requestFormModel";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { API_REQUEST_FULLFILLED, MESSAGE_PROCESSING_DETAILS, MESSAGE_SUBMIT } from "../../app/utils/constant";
import { RequestToWithdrawPcsValidationSchema } from "./models/requestValidationSchemas";
import SuccessResponse from "./models/SuccessResponse";
import { toast } from "react-toastify";
import { useAppDispatch } from "../../app/store/configureStore";
import { useState } from "react";
import { CreateRequestTaskCommand } from "../../app/models/request/createRequestTaskCommand";
import { RequestTypesEnum } from "../../app/enums/requestTypesEnum";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { submitRequestAsync } from "../../app/slices/requestSlice";

export default function RequestToWithdrawPcs() {
    const methods = useForm({
        mode: 'all',
        resolver: yupResolver(RequestToWithdrawPcsValidationSchema)
    });
    const { control, trigger, formState: { isDirty } } = methods;
    const formObj = methods.watch();

    const {
        RequestToWithdraw: {
            Reason
        }
    } = RequestFormModel;

    const dispatch = useAppDispatch();

    const [pageLoading, setPageLoading] = useState(false);
    const [isRequestSubmitted, setIsRequestSubmitted] = useState(false);

    const MapToRequestDetails = () => {
        let requestObj: CreateRequestTaskCommand = {
            requestTypeCode: RequestTypesEnum.RequestToWithdraw.toString(),
            details: `${Reason.label.replace('*', '')}: ${formObj.Reason}`,
            subject: ''
        };

        return requestObj;
    }

    const successMessage = `Request sent successfully.`;

    const handleSave = async () => {
        const isStepValid = await trigger();
        if (!isStepValid) {
            trackPortalEvent(portalScreenContext(PortalTelemetryScreen.RequestToWithdrawPcs),
                PortalTelemetryEvent.ValidationBlocked, {
                step: undefined,
                validationErrors: validationIssues(PortalTelemetryScreen.RequestToWithdrawPcs, methods.getFieldState)
            });
        }

        if (isStepValid) {
            if (isDirty === true) {
                setPageLoading(true);
                dispatch(submitRequestAsync(MapToRequestDetails())).then((requestResponse: any) => {
                    if (requestResponse.meta.requestStatus.toLowerCase() === API_REQUEST_FULLFILLED) {
                        setPageLoading(false);
                        setIsRequestSubmitted(true);
                        toast.success(successMessage);
                    }
                });
            }
        }
    };

    usePortalScreen(portalScreenContext(PortalTelemetryScreen.RequestToWithdrawPcs), undefined, !((pageLoading === true)));

    if (pageLoading === true) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
    }

    if (isRequestSubmitted === true) {
        return <SuccessResponse message={successMessage} />
    }

    return <>
        <Box sx={{ minWidth: "100%" }} component={Paper}>
            <Grid container rowSpacing={4} sx={{ ml: '2%', width: '96%' }}>

                <Grid size={{ xs: 12 }}></Grid>

                <Grid size={{ xs: 12 }}>
                    <BackToRequests />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Typography variant='h4'>Request to withdraw</Typography>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    If you wish to withdraw from the RCSI Professional Competence Scheme, please
                    notify this office by completing this form.
                    <br></br>
                    <br></br>
                    You might want to withdraw based on the following reasons:
                    <ul>
                        <li>You are no longer registered with the Medical Council so are not required to enrol in PCS.</li>
                        <li>You are now enrolled in a formal (Medical Council accredited) training programme.</li>
                        <li>You have changed specialty and are enrolling in a PCS scheme operated by a different training body.</li>
                    </ul>
                    This will allow us update our records and ensure that you do not receive
                    unnecessary communication in relation to the PCS.
                </Grid>

                <Grid size={{ xs: 12 }}></Grid>
            </Grid>
        </Box>

        <Box sx={{ minWidth: "100%" }} component={Paper}>
            <Grid container rowSpacing={4} sx={{ margin: "2%" }}>

                <Grid size={{ xs: 12 }}></Grid>

                <Grid size={{ xs: 12 }}>
                    <Typography variant="body1">
                        I wish to withdraw from the Professional Competence Scheme.
                    </Typography>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppTextareaInput control={control} name={Reason.name} label={Reason.label}
                        maxStringCount={Reason.maxStringCount} />
                </Grid>

                <Grid size={{ xs: 12 }}></Grid>

            </Grid>
        </Box>

        <Box>
            <Grid container rowSpacing={4}>
                <Grid size={{ xs: 12 }}></Grid>

                <Grid size={{ xs: 8 }}></Grid>

                <Grid size={{ xs: 3 }} sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Button variant="contained" color="primary" onClick={portalAction(portalScreenContext(PortalTelemetryScreen.RequestToWithdrawPcs), `${PortalTelemetryScreen.RequestToWithdrawPcs}.onClick.handleSave`, handleSave)}>
                        {MESSAGE_SUBMIT}
                    </Button>
                </Grid>

                <Grid size={{ xs: 1 }}></Grid>
            </Grid>
        </Box>
    </>
}